import CurrencyInput from "react-currency-input-field";
import { Box, Typography, useTheme } from "@mui/material";
import TextField from "@mui/material/TextField";
import { tokens } from "../../theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect } from "react";

import LoadingButton from "@mui/lab/LoadingButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { XyzTransition } from "@animxyz/react";

import ProductsFromServer from "../select-products";

export const CreditCardPay = ({ handlerChangeCurrency, value, handleStep, payOption, times, handleChangePayOptiopn, handleChangeTimes, setTimes, handleInputChangeProducts, productsSell, handleRemoveProduct }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	const [open, setOpen] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");


	const handleClose = () => {
		setOpen(false);
	};

	const handleOpen = () => {
		setOpen(true);
	};

	const handlerBlurCurrency = () => {
		if (value < 10) {
			setErrorMsg("Valor Deve ser Maior ou igual a R$ 10,00");
		} else setErrorMsg("");
	};

	useEffect(
		() => {
			setTimes(1);
		},
		[payOption]
	);
	
	useEffect(
		() => {
			if(value < 60){
				setTimes(1);
			}
		},
		[value]
	);

	console.log('value :', value)

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
			p="10px"
			sx={{
				gap: "20px",
				width: "100%",
			}}
		>
			<ProductsFromServer 
			handleInputChangeProducts={handleInputChangeProducts}
			productsSell={productsSell}
			handleRemoveProduct={handleRemoveProduct}
			/>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				p="10px"
				sx={{
					gap: "30px",
					width: "100%",
					minHeight: "400px",
					backgroundColor: colors.pink[600],
					border: " 1px solid black",
					borderRadius: "10px",
					padding: "20px",
					"& .MuiInputBase-input": {
						backgroundColor: `${colors.pink[700]} !important`
					},
					"& .MuiFormHelperText-root": {
						color: "yellow",
						fontStyle: "italic"
					}
				}}
			>
				<Typography variant="h3" color={colors.primary[100]}>
					Valor a Pagar:
				</Typography>
				{value > 0
					? <Typography variant="h2" color={colors.primary[100]}>
							{parseFloat(value).toLocaleString("pt-br", {
								style: "currency",
								currency: "BRL"
							})}
						</Typography>
					: <Typography variant="h2" color={colors.primary[100]}>
							R$ 0,00
						</Typography>}
				<CurrencyInput
					customInput={TextField}
					variant="outlined"
					label="Insira o valor caso seja diferente"
					maxLength="7"
					type="tel"
					id="input-example"
					name="input-name"
					placeholder="R$ "
					prefix="R$ "
					decimalsLimit={2}
					decimalSeparator=","
					groupSeparator="."
					helperText={errorMsg}
					onValueChange={(value, name) =>
						handlerChangeCurrency(value)}
					onBlur={handlerBlurCurrency}
					sx={{
						width: isNonMobile ? "50%" : "80%",
						fontSize: "20px",
						backgroundColor: colors.pink[600],
						borderRadius: "4px",
						"& MuiInputBase-root.Mui-focused": {
							color: `${colors.grey[200]} !important`,
							fontWeight: "bold"
						},
						"& .MuiFormLabel-root.Mui-focused": {
							color: `${colors.grey[200]} !important`,
							fontWeight: "bold",
							fontSize: "12px"
						}
					}}
				/>
				{/* AVISTA OU PARCELA */}
				<FormControl>
					{/* <FormLabel id="demo-radio-buttons-group-label">
						Gender
					</FormLabel> */}
					<RadioGroup
						aria-labelledby="demo-radio-buttons-group-label"
						defaultValue="female"
						name="radio-buttons-group"
						value={payOption}
						onChange={handleChangePayOptiopn}
					>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
						>
							<FormControlLabel
								value="vista"
								control={<Radio />}
								label="À Vista"
								disabled={value.length === 0 || value < 10}
							/>
							<FormControlLabel
								value="parcelado"
								control={<Radio />}
								label="Parcelado"
								disabled={value.length === 0 || value < 60}
							/>
						</Box>
					</RadioGroup>
				</FormControl>
				{/* PARCELAS */}

				{payOption === "parcelado" && value >= 60

					? <XyzTransition
							appear
							mode="out-in"
							xyz="small-100% origin-top"
						>
							<Box>
								<FormControl sx={{ m: 1, minWidth: 120 }}>
									<InputLabel id="demo-controlled-open-select-label">
										Parcelas
									</InputLabel>
									<Select
										labelId="demo-controlled-open-select-label"
										id="demo-controlled-open-select"
										open={open}
										onClose={handleClose}
										onOpen={handleOpen}
										value={times}
										label="Age"
										onChange={handleChangeTimes}
									>
										<MenuItem value={1}>
											1x de{" "}
											{(value / 1).toLocaleString("pt-br", {
												style: "currency",
												currency: "BRL"
											})}
										</MenuItem>
										{value / 2 >= 30 &&
											<MenuItem value={2}>
												2x de{" "}
												{(value /
													2).toLocaleString("pt-br", {
													style: "currency",
													currency: "BRL"
												})}
											</MenuItem>}
										{value / 3 >= 30 &&
											<MenuItem value={3}>
												3x de{" "}
												{(value /
													3).toLocaleString("pt-br", {
													style: "currency",
													currency: "BRL"
												})}
											</MenuItem>}
									</Select>
								</FormControl>
							</Box>
						</XyzTransition>
					: null}
			</Box>
			<LoadingButton
				loading={false}
				type="submit"
				sx={{
					backgroundColor: colors.greenAccent[600],
					width: isNonMobile ? "100%" : "100%",
					borderRadius: "60px",
					marginTop: "20px"
				}}
				variant="contained"
				disabled={!value || value < 10 || productsSell.length === 0}
				onClick={handleStep}
				// disabled={isValid}
			>
				Avançar
			</LoadingButton>
		</Box>
	);
};

export default CreditCardPay;
